import { makeStyles } from '@material-ui/core/styles';
import { darken, lighten } from 'polished';

export default makeStyles((theme) => ({
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  container: {
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: '#fff',
    padding: '1.75rem 2rem',
    borderRadius: '0.5rem',
    maxWidth: '25rem',
  },
  closeButton: {
    width: '1.5rem',
    height: '1.5rem',
    borderRadius: '50%',
    backgroundColor: 'rgba(215, 222, 233, 0.25)',
    color: '#4f4f4f',
    padding: 0,
  },
  warningIconWrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '5rem',
    height: '5rem',
    borderRadius: '50%',
    backgroundColor: 'rgba(246, 68, 68, 0.2)',
  },
  title: {
    color: '#101d40',
    fontSize: '1.5rem',
    textAlign: 'center',
    fontWeight: 800,
    marginTop: '0.938rem',
    fontFamily: 'Sora, sans-serif',
  },
  description: {
    textAlign: 'center',
    marginTop: '0.625rem', 
    fontFamily: 'Sora, sans-serif',
    fontSize: '0.875.rem',
    color: '#7c8db5',
  },
  button: {
    padding: '0.813rem 1.125rem',
    borderRadius: '0.313rem',
    fontFamily: 'Sora, sans-serif',
    fontWeight: 600,
    fontSize: '0.938rem',
    marginTop: '0.625rem',
  },
  confirmButton: {
    backgroundColor: '#329bfc',
    color: '#ffffff',
    '&:hover': {
      backgroundColor: darken(0.1, '#329bfc'),
    },
  },
  cancelButton: {
    color: '#329bfc',
    borderColor: '#329bfc',
    '&:hover': {
      backgrounColor: lighten(0.38, '#329bfc'),
    },
  },
}));
